import { RoleMap } from './useGetRole';
import { useProfile } from './useProfile';

export const useIsMasterAccount = (): boolean | undefined => {
  const { profile, loading } = useProfile();

  if (loading) return;

  if (!profile) return false;

  return profile.role.includes(RoleMap.master);
};
